import { t } from '@lingui/core/macro';

import PaidSearchOverviewActions from '@/app/paid-search/PaidSearchOverviewActions';
import PaidSearchOverviewContent from '@/app/paid-search/PaidSearchOverviewContent';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';

const PaidSearchOverview = () => {
  return (
    <Page title={t`Paid Search`} exampleAIQuestions={[]}>
      <PageFilterProvider>
        <div className="flex w-full flex-col gap-6">
          <div className="flex items-start justify-between">
            <PageDateRangeFilter />
            <PaidSearchOverviewActions />
          </div>
          <PaidSearchOverviewContent />
        </div>
      </PageFilterProvider>
    </Page>
  );
};

export default PaidSearchOverview;
